module.exports = __webpack_public_path__ + "static/media/sku219401033-A.cef62cda.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/parts/images/sku219401033-A.png
// module id = 562
// module chunks = 0